module.exports = __webpack_public_path__ + "static/support-d97816c785078137fd43f05739305a3a.jpg";